import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutContent, testimonials } from '@/mocks/about';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-12">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mt-4">
              关于我们
            </h1>
            <p className="text-foreground-600 text-sm md:text-base mt-3 max-w-2xl">
              {aboutContent.tagline}
            </p>
          </div>
        </div>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-5">
                  我们的故事
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  {aboutContent.story}
                </p>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  {aboutContent.introduction}
                </p>
                <p className="text-foreground-600 leading-relaxed">
                  {aboutContent.mission}
                </p>
              </div>
              <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20workspace%20with%20cream%20walls%2C%20wooden%20desk%2C%20scattered%20notebooks%20and%20dried%20flowers%2C%20soft%20natural%20light%20from%20window%2C%20feminine%20sophisticated%20atmosphere%2C%20editorial%20interior%20photography%2C%20creative%20studio%20vibe&width=800&height=600&seq=about-story-14&orientation=portrait"
                  alt={aboutContent.brandName}
                  title={`${aboutContent.brandName} - 工作室`}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                她们说
              </h2>
              <p className="text-foreground-600 text-sm">来自真实读者的心声</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className="p-6 rounded-xl bg-background-50 border border-background-200/60"
                >
                  <div className="flex items-center gap-1 mb-3 text-primary-400">
                    {[...Array(5)].map((_, j) => (
                      <i key={j} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{t.text}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100/70 flex items-center justify-center">
                      <span className="text-sm font-semibold text-primary-600">
                        {t.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                联系我们
              </h2>
              <p className="text-foreground-600 text-sm">有任何问题或建议？我们很乐意倾听</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-100/70 text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  电子邮件
                </h3>
                <p className="text-sm text-foreground-600">{aboutContent.contact.email}</p>
              </div>

              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-accent-100/70 text-accent-600">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  微信
                </h3>
                <p className="text-sm text-foreground-600">{aboutContent.contact.wechat}</p>
              </div>

              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-secondary-100/70 text-secondary-600">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  地址
                </h3>
                <p className="text-sm text-foreground-600">{aboutContent.contact.address}</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 第一次人妻完全指南',
            description: aboutContent.tagline,
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://firstwife.guide/' },
                { '@type': 'ListItem', position: 2, name: '关于我们' },
              ],
            },
          }),
        }}
      />
    </>
  );
}